/*******************/
// Button - Start
/*******************/

export const ButtonVariantType = {
	Primary: 'primary',
	Destructive: 'destructive',
	Outline: 'outline',
	Secondary: 'secondary',
	Ghost: 'ghost',
} as const;

export type ButtonVariantTypes =
	(typeof ButtonVariantType)[keyof typeof ButtonVariantType];

export const ButtonSize = {
	Medium: 'md',
	Small: 'sm',
	Large: 'lg',
	XL: 'xl',
} as const;

export type ButtonSizes = (typeof ButtonSize)[keyof typeof ButtonSize];

export const TypeofButton = {
	Button: 'button',
	Submit: 'submit',
	Reset: 'reset',
} as const;

export type TypeofButtons = (typeof TypeofButton)[keyof typeof TypeofButton];

export type ButtonIconType = {
	iconType: React.ReactNode;
	orientation: 'left' | 'right' | 'default';
};

/*******************/
// Button - End
/*******************/

export const TypeofInput = {
	Text: 'text',
	Email: 'email',
	Password: 'password',
	File: 'file',
	Number: 'number',
	Date: 'date',
} as const;

export type TypeofInputs = (typeof TypeofInput)[keyof typeof TypeofInput];

/*******************/
// Component types
/*******************/

export const ComponentType = {
	Button: 'Button',
	Avatar: 'Avatar',
	Bubble: 'Bubble',
	Checkbox: 'Checkbox',
	Dropdown: 'Dropdown',
	Input: 'Input',
	Radio: 'Radio',
	Switch: 'Switch',
	Separator: 'Separator',
	List: 'List',
} as const;

export type ComponentTypes = (typeof ComponentType)[keyof typeof ComponentType];

/*********************/
// Component types End
/*********************/

/**********************/
// Chatbot Config types
/**********************/

export type AppConfig = {
	title?: string;
	chatBotName?: string;
	chatBotAvatar?: string;
	minimizedIcon?: string;
	welcomeMessage?: string;
	expandChatText?: string;
	minimizedChatText?: string;
	baseUrl: string;
	humanHandoverUrl: string;
	theme?: {
		font?: string;
		primary?: {
			color: string;
			textColor: string;
		};
		secondary?: {
			color: string;
			textColor: string;
		};
	};
};

/**************************/
// Chatbot Config types End
/**************************/
